<template>
    <v-container fluid class="pa-0 elasticbase-container">
        <v-row column justify-center align-center>
            <v-menu
                :nudge-width="200"
                offset-x
                transition="slide-x-transition"
                v-if="$vuetify.breakpoint.mdAndUp"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        color="primary"
                        bottom
                        left
                        fixed
                        x-large
                        v-bind="attrs"
                        v-on="on"
                    >
                        <div class="menu-icon-wrapper">
                            <fa
                                :icon="['fal', 'tag']"
                                class="fa-lg"
                                style="color: #ffff"
                            />
                            <span
                                class="menu-icon-subtext menu-icon-subtext-local"
                                style="color: #ffff"
                                >Selections</span
                            >
                        </div>
                    </v-btn>
                </template>
                <v-card>
                    <v-col
                        v-show="
                            SelectedFacets.length === 0 &&
                            data.length > 0 &&
                            $vuetify.breakpoint.mdAndUp
                        "
                        >No Category selected</v-col
                    >
                    <v-col
                        v-show="
                            SelectedFacets.length > 0 &&
                            data.length > 0 &&
                            $vuetify.breakpoint.mdAndUp
                        "
                        id="chip-wrapper"
                        cols="12"
                        style="display: flex; flex-wrap: wrap"
                    >
                        <v-chip color="transparent" style="color: #0063a6"
                            >Selections:</v-chip
                        >
                        <div
                            v-for="facet in SelectedFacets"
                            :key="facet.name"
                            class="d-flex"
                        >
                            <v-chip
                                color="transparent"
                                style="color: #0063a6"
                                v-if="facet.value.length !== 0"
                                >{{ facet.name }}:</v-chip
                            >
                            <div
                                v-if="facet.type === 'multiple'"
                                style="width: fit-content"
                            >
                                <template v-for="val in facet.value">
                                    <slot
                                        name="selectedItem"
                                        v-bind="val"
                                        color="#ffffff"
                                    ></slot>
                                </template>
                            </div>
                            <div v-else>
                                <template>
                                    <slot
                                        name="selectedItem"
                                        v-bind="facet"
                                        color="#ffffff"
                                    ></slot>
                                </template>
                            </div>
                        </div>
                        <v-chip color="primary" style="color: #ffffff">
                            <a
                                href="/shop/"
                                style="color: #ffffff; text-decoration: none"
                                >CLEAR ALL</a
                            >
                        </v-chip>
                    </v-col>
                </v-card>
            </v-menu>
            <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" sm="4" md="3">
                <client-only>
                    <vue-sticky-sidebar
                        container-selector=".elasticbase-container"
                        :bottom-spacing="100"
                    >
                        <template v-for="facet in filtersToRender">
                            <slot
                                v-if="$scopedSlots[facet.name]"
                                :name="facet.name"
                                v-bind="facet"
                                :onChange="
                                    (val) => set_facetValue(facet.name, val)
                                "
                            ></slot>

                            <template
                                v-else-if="
                                    facet.type == 'single' ||
                                    facet.type == 'multiple'
                                "
                            >
                                <FacetCard
                                    :key="facet.name"
                                    :name="facet.name"
                                    :data="facet.data"
                                    :is-multiple="facet.type === 'multiple'"
                                    :value="facet.value"
                                    @change="
                                        (val) => set_facetValue(facet.name, val)
                                    "
                                    @sortData="sortDataCards"
                                />
                            </template>
                            <template v-else-if="facet.type == 'range'">
                                <FacetRangeCard
                                    :key="facet.name"
                                    :name="facet.name"
                                    :data="facet.data"
                                    :value="facet.value"
                                    @change="
                                        (val) => set_facetValue(facet.name, val)
                                    "
                                />
                            </template>
                        </template>
                    </vue-sticky-sidebar>
                </client-only>
            </v-col>
            <v-col cols="12" sm="12" md="9">
                <div
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="autoLoadDisabled"
                >
                    <slot
                        :data="data"
                        :loadingData="loadingData"
                        name="list"
                    ></slot>
                    <div class="text-center mt-5">
                        <v-btn
                            v-if="data && data.length > 0 && isMaxLimitReached"
                            color="primary"
                            @click="loadMoreOnClick()"
                            ><TranslatableStringComponent
                                :tstring="{ string: 'loadMoreProducts' }"
                        /></v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-bottom-navigation
            v-if="$vuetify.breakpoint.smAndDown"
            hide-on-scroll
            fixed
            horizontal
        >
            <v-btn value="filter" block text @click.stop="handleDrawer()">
                <span>
                    <fa :icon="['fal', 'filter']" class="fa-lg mr-2" />
                    <TranslatableStringComponent
                        :tstring="{ string: 'filterProducts' }"
                    />
                </span>
            </v-btn>
        </v-bottom-navigation>
        <v-dialog v-model="drawer" fullscreen>
            <v-card style="background-color: #f5f5f6">
                <div
                    class="pa-3"
                    style="
                        background-color: #ffffff;
                        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
                    "
                >
                    <div><span>FILTERS</span></div>
                </div>

                <div>
                    <v-container class="pa-0 pb-15">
                        <v-row class="ml-0 mr-0">
                            <v-col
                                cols="5"
                                class="pa-0"
                                style="height: 650px; overflow: auto"
                            >
                                <v-list dense>
                                    <v-list-item-group
                                        v-model="selectedFilter"
                                        color="primary"
                                    >
                                        <v-list-item
                                            v-for="(
                                                facet, i
                                            ) in mobileFiltersToRender"
                                            :key="i"
                                            style="
                                                border-bottom: 1px solid
                                                    rgba(0, 0, 0, 0.12);
                                            "
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    v-html="
                                                        breakLine(facet.name)
                                                    "
                                                ></v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action class="ml-0">
                                                {{ fetchCount(facet.name) }}
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                            <v-col
                                cols="7"
                                class="pa-0"
                                style="
                                    background-color: #ffffff;
                                    height: 650px;
                                    overflow: auto;
                                    border-left: 1px solid rgba(0, 0, 0, 0.12);
                                "
                            >
                                <div
                                    v-show="
                                        filterSelected !== undefined &&
                                        filterSelected.name === 'Categories'
                                    "
                                >
                                    <v-text-field
                                        v-model="search"
                                        label="Filter Categories"
                                        dense
                                        flat
                                        solo-inverted
                                        hide-details
                                        class="facets-input--filter"
                                        :class="{
                                            'pa-2':
                                                $vuetify.breakpoint.smAndDown,
                                        }"
                                    >
                                        <v-icon slot="append" dense>
                                            fa-times
                                        </v-icon>
                                    </v-text-field>
                                    <v-treeview
                                        class="treeview-mobile"
                                        :items="categoryTreeItems"
                                        hoverable
                                        dense
                                        :search="search"
                                        open-on-click
                                        item-key="name"
                                        selectable
                                        @input="
                                            (val) =>
                                                set_facetValue(
                                                    filterSelected.name,
                                                    val
                                                )
                                        "
                                    />
                                </div>
                                <div
                                    v-show="
                                        filterSelected !== undefined &&
                                        filterSelected.name !== 'Categories'
                                    "
                                >
                                    <template
                                        v-for="facet in mobileFiltersToRender"
                                    >
                                        <FacetCardMobile
                                            v-if="
                                                filterSelected &&
                                                filterSelected.name ===
                                                    facet.name
                                            "
                                            :key="facet.name"
                                            :name="facet.name"
                                            :data="facet.data"
                                            :is-multiple="
                                                facet.type === 'multiple'
                                            "
                                            :value="facet.value"
                                            :selected-facets="SelectedFacets"
                                            @change="
                                                (val) =>
                                                    set_facetValue(
                                                        facet.name,
                                                        val
                                                    )
                                            "
                                        />
                                    </template>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-card>
            <v-bottom-navigation
                v-if="$vuetify.breakpoint.smAndDown"
                v-model="closeNav"
                fixed
                horizontal
            >
                <v-btn value="close" block text @click.stop="handleDrawer()">
                    <span>
                        <fa
                            :icon="['fal', 'times']"
                            class="fa-lg mr-2"
                        />close</span
                    >
                </v-btn>
            </v-bottom-navigation>
        </v-dialog>
        <v-overlay
            :absolute="true"
            :value="loadingData"
            color="#fff"
            opacity="0.46"
        >
            <v-progress-circular
                class="shop-page-loader"
                :size="50"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
import _ from 'lodash'

import FacetCard from '~/components/Elasticbase/FacetCard.vue'
import FacetRangeCard from '~/components/Elasticbase/FacetRangeCard.vue'
import FacetCardMobile from '~/components/Elasticbase/FacetCardMobile.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

export default {
    name: 'Elasticbase',
    components: {
        FacetCard,
        FacetRangeCard,
        FacetCardMobile,
        TranslatableStringComponent,
    },
    props: {
        facets: {
            type: Array,
            default: () => [],
        },
        size: {
            type: Number,
            default: 12,
        },
        categoryTreeItems: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            from: 0,
            filters: [],
            search: null,
            data: [],
            maxItemsOnScroll: 36,
            closeNav: '',
            drawer: false,
            selectedFilter: 0,
            loadingData: false,
            showSelections: false,
        }
    },
    computed: {
        SelectedFacets() {
            return _.flatten(
                this.filters
                    .filter((f) => f.value != null)
                    .map((f) => {
                        if (f.type === 'single') {
                            return {
                                type: 'single',
                                label: `${f.value[0]}`,
                                name: `${f.name}`,
                                remove: () =>
                                    this.set_facetValue(f.name, null, true),
                            }
                        } else if (f.type === 'multiple') {
                            return {
                                type: 'multiple',
                                name: `${f.name}`,
                                value: f.value.map((value) => ({
                                    label:
                                        f.name === 'Categories'
                                            ? `${this.getParentValue(
                                                  value
                                              )}${value}`
                                            : `${value}`,
                                    remove: () => {
                                        const v = f.value.filter(
                                            (v) => v !== value
                                        )
                                        this.set_facetValue(
                                            f.name,
                                            v.length === 0 ? null : v,
                                            true
                                        )
                                    },
                                })),
                            }
                        } else if (f.type === 'range') {
                            return {
                                type: 'range',
                                label: `${f.value[0]} - ${f.value[1]}`,
                                name: `${f.name}`,
                                remove: () =>
                                    this.set_facetValue(f.name, null, true),
                            }
                        } else {
                            return {
                                label: f.value,
                                remove: () =>
                                    this.set_facetValue(f.name, null, true),
                            }
                        }
                    })
            )
        },
        autoLoadDisabled() {
            return this.data.length === 0
        },
        isMaxLimitReached() {
            return this.data.length >= 12
        },
        filtersToRender() {
            return this.filters.filter((f) =>
                f.shouldAggregate ? f.shouldAggregate(this.filters) : true
            )
        },
        mobileFiltersToRender() {
            return [...this.filtersToRender].filter((item, i) => i > 0)
        },
        filterSelected() {
            return this.mobileFiltersToRender[this.selectedFilter]
        },
    },
    created() {
        this.modifyFacets()
    },
    mounted() {
        const filtersToAggregate = this.filters.filter((f) => !f.custom)
        this.setFacets(filtersToAggregate)
        this.set_data()
    },
    methods: {
        async set_data() {
            this.loadingData = true
            const res = await this.$axios.post('elastic-search', {
                elasticQuery: {
                    ...this.getQueryByFilter(),
                },
                elasticIndex: 'products-sanity',
            })
            this.data = [
                ...this.data,
                ..._.map(res.data.hits.hits, (p) => ({
                    ...p._source,
                    _id: p._source.product_id,
                    pkgqty: p._source.pkgqty || 1,
                })),
            ]
            this.loadingData = false
        },
        async setFacets(filters) {
            const res = await this.$axios.post('elastic-search', {
                elasticQuery: {
                    size: 0,
                    ...this.getQueryByFilter(),
                    ...this.getAgg(filters),
                },
                elasticIndex: 'products-sanity',
            })
            const facetsData = res.data.aggregations
            filters.forEach((facet) => {
                if (facet.type === 'single' || facet.type === 'multiple') {
                    facet.data =
                        facetsData &&
                        facetsData[facet.name] &&
                        facetsData[facet.name].buckets
                            ? facetsData[facet.name].buckets
                            : []
                } else if (facet.type === 'range') {
                    facet.data = {
                        max: facetsData[`max_${facet.name}`].value,
                        min: facetsData[`min_${facet.name}`].value,
                    }
                }
            })
        },
        getQueryByFilter() {
            const filters = this.filters
                .filter((f) => f.value != null)
                .filter((f) =>
                    Array.isArray(f.value) ? f.value.length > 0 : true
                )
                .map((f) => {
                    if (f.type === 'single') {
                        return { term: { [`${f.property}`]: f.value[0] } }
                    } else if (f.type === 'multiple') {
                        return { terms: { [`${f.property}`]: f.value } }
                    } else if (f.type === 'range') {
                        return {
                            range: {
                                [f.property]: {
                                    gte: f.value[0],
                                    lte: f.value[1],
                                },
                            },
                        }
                    } else if (f.type === 'custom') {
                        return f.query(f.value)
                    }
                })
            if (filters.length === 0)
                return { from: this.from, size: this.size }
            return {
                from: this.from,
                size: this.size,
                query: {
                    bool: {
                        must: filters,
                    },
                },
            }
        },
        getAgg(filters) {
            const aggs = filters
                .filter((f) => f.aggregate)
                .filter((f) =>
                    f.shouldAggregate ? f.shouldAggregate(this.filters) : true
                )
                .map((f) => {
                    if (f.type === 'single' || f.type === 'multiple') {
                        return {
                            [`${f.name}`]: {
                                terms: {
                                    field: f.property,
                                    size: 999,
                                    order: { _key: 'asc' },
                                },
                            },
                        }
                    } else if (f.type === 'range') {
                        return {
                            [`max_${f.name}`]: {
                                max: {
                                    field: f.property,
                                },
                            },
                            [`min_${f.name}`]: {
                                min: {
                                    field: f.property,
                                },
                            },
                        }
                    }
                })
            if (aggs.length === 0) return {}
            return {
                // size: 0,
                aggs: aggs.reduce((objAll, obj) => ({ ...objAll, ...obj }), {}),
            }
        },
        set_facetValue(facetName, value, resetSelf = false) {
            this.filters.find((f) => f.name === facetName).value = value
            this.filters.forEach((f) => {
                if (
                    f.shouldAggregate &&
                    f.shouldAggregate(this.filters) === false
                ) {
                    f.value = null
                }
            })
            this.from = 0
            this.data = []
            this.set_data()
            this.setALLCorrespondingFacets(facetName, resetSelf)
            this.syncQueryParams(facetName, value)
        },
        setALLCorrespondingFacets(facetName, resetSelf) {
            const facet = _.find(this.filters, { name: facetName })
            let allCorrespondingFacets = this.filters.filter(
                (f) => f.name !== facetName
            )
            if (resetSelf) {
                allCorrespondingFacets = [facet, ...allCorrespondingFacets]
            }
            this.setFacets(allCorrespondingFacets)
        },
        loadMore: _.throttle(function () {
            if (this.isMaxLimitReached) {
                return
            }
            this.from += this.size
            this.set_data()
        }, 1000),
        //     loadMore: function() {
        //         console.log(this.isMaxLimitReached)
        //         if(this.isMaxLimitReached)
        //             return
        //         this.busy = true;
        //         setTimeout(() => {
        //             this.from += this.size
        //             this.set_data()
        //             this.busy = false
        //   }, 5000)
        // },

        loadMoreOnClick() {
            this.from += this.size
            this.set_data()
        },
        syncQueryParams(facetName, value) {
            const query = this.filters
                .map((f) => ({ [f.name]: f.value }))
                .reduce((acc, f) => ({ ...acc, ...f }), {})
            this.$router.push({
                query: _.pickBy(query, _.identity),
            })
        },
        handleDrawer() {
            this.drawer = !this.drawer
        },
        fetchCount(facetName) {
            const count = this.SelectedFacets.reduce((acc, curr) => {
                if (curr.name === facetName) {
                    return acc + 1
                } else {
                    return acc + 0
                }
            }, 0)
            return count > 0 ? count : ''
        },
        modifyFacets() {
            this.filters = this.facets.map((f) => {
                if (f.type === 'range') {
                    return {
                        ...f,
                        value: this.$route.query[f.name] || null,
                        data: { max: 0, min: 0 },
                    }
                } else if (f.type === 'multiple') {
                    let val = this.$route.query[f.name] || null
                    if (val && Array.isArray(val) === false) {
                        val = [val]
                    }
                    return {
                        ...f,
                        value: val,
                        data: [],
                    }
                } else {
                    return {
                        ...f,
                        value: this.$route.query[f.name] || null,
                        data: [],
                    }
                }
            })
        },
        breakLine(line) {
            if (!this.$vuetify.breakpoint.smAndUp) {
                const words = line.split(' ')
                return words.join('<br>')
            } else {
                return line
            }
        },
        sortDataCards(name, sort) {
            this.data.sort((a, b) => {
                let fa = a.attributes[name],
                    fb = b.attributes[name]

                if (fa < fb) {
                    return sort ? -1 : 1
                }
                if (fa > fb) {
                    return sort ? 1 : -1
                }
                return 0
            })
        },
        getParentValue(value) {
            let parent = ''
            this.categoryTreeItems.map((ct) => {
                if (ct.children.some((c) => c.name === value))
                    parent = `${ct.name} : `
                else parent === '' ? '' : parent
            })
            return parent
        },
    },
}
</script>
<style lang="scss">
.shop-page-loader {
    position: fixed;
    top: 50%;
}
.menu-icon-subtext-local {
    left: -13px;
    bottom: -13px;
}
.v-menu__content {
    margin-left: 15px !important;
}
.v-treeview--dense .v-treeview-node__root {
    min-height: 0px;
}
.v-treeview-node--click > .v-treeview-node__root,
.v-treeview-node--click
    > .v-treeview-node__root
    > .v-treeview-node__content
    > * {
    white-space: normal !important;
}
</style>
